module.exports = __webpack_public_path__ + "baf2a107e7981ef5cf225096b26b503f.png";